const AroundSceneInit = () => {
  return (
    <a-scene
      embedded
      webar-scene
      renderer="logarithmicDepthBuffer: true; colorManagement: true; precision: mediump"
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      // physics="iterations: 1;"
      xrweb="allowedDevices: any"
      // gesture-detector
      gltf-model="dracoDecoderPath: https://rhym.s3.ap-south-1.amazonaws.com/draco/"
      // cursor="fuse: false; rayOrigin: mouse;"
      // raycaster="objects: .clickable, .cursor-clickable"
      id="scene"
    >
      <a-light type="ambient" color="#ffffff"></a-light>

      <a-light type="directional" position="-1 2 1"></a-light>

      <a-assets></a-assets>

      <a-camera
        id="camera"
        position="0 0 0"
        tone-mapping="algorithm: reinhard;"
        cursor="fuse: false; rayOrigin: mouse;"
        raycaster="objects: .clickable"
        fov="60"
        zoom="2"
      ></a-camera>

      <a-entity
        id="webar_stage"
        grid="size: 10; divisions: 10; color: #00F; opacity: 0.3"
        position="0 0 0"
      >
        <a-entity>
          <a-entity id="entity_elements" visible="true"></a-entity>
        </a-entity>
      </a-entity>
      <a-box
        id="ground"
        scale="1000 2 1000"
        position="0 -1 0"
        material="shader: shadow; transparent: true; opacity: 0.4; pointer-events: none"
        shadow
      ></a-box>
    </a-scene>
  );
};

export default AroundSceneInit;
